import { render, staticRenderFns } from "./ModalButtonCancel.vue?vue&type=template&id=08cfecd4&scoped=true&"
import script from "./ModalButtonCancel.vue?vue&type=script&lang=js&"
export * from "./ModalButtonCancel.vue?vue&type=script&lang=js&"
import style0 from "./ModalButtonCancel.vue?vue&type=style&index=0&id=08cfecd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfecd4",
  null
  
)

export default component.exports